/** Maps the Eloqua id of forms to more human readable names */
/**
 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
 *** WHEN YOU ADD A FORM MAKE SURE TO UPDATE simpleIdToActionMap
 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
 */
class FormIdUtil {
    /** Returns true if this a Product signup for (i.e. makes a request to cad invite) */
    static isCadInviteForm({ formId }) {
        return (formId === FormIdUtil.names.unifiedSignup ||
            formId === FormIdUtil.names.upgradeToEducator ||
            formId === FormIdUtil.names.camForFirstRobotics ||
            formId === FormIdUtil.names.referToDisco);
    }
    static isUnifiedSignupForm({ formId }) {
        return formId === FormIdUtil.names.unifiedSignup;
    }
}
FormIdUtil.names = {
    defaultContentDownloadLead: '23',
    contactUs: '32',
    demoRequest: '36',
    webinarRegistration: '46',
    webinarRegistration2023: '179',
    eduEnterpriseRequest: '54',
    startupProgram: '60',
    wwwContactSales: '152',
    eduAcademicWebinarRegistration: '99',
    gatedContentProgressiveProfile: '125', // DEPRECATED
    productSignupLandingPageHidden: '127',
    wwwGetStartedContact: '136',
    trialHiddenForm: '137',
    eduProductSignupHidden: '139', // DEPRECATED
    requestProTrialFromFree: '45',
    upgradeRenderStudio: '163',
    upgradeStandardToPro: '166',
    collegiateSponsorship: '172',
    contactSales: '152',
    eduForm: '168',
    eventForm: '101',
    mdaEventForm: '184',
    camStudioForm: '185',
    referAFriendReferrer: '149',
    referAFriendReferred: '150',
    internalReferral: '160',
    emailSubscriptionPreferences: '151',
    signupSurvey: '181',
    creatorProgram: '180',
    unifiedSignup: '182',
    upgradeToEducator: '193',
    referToDisco: '195',
    /** Used as a form to qa for Uptime */
    qaHeartBeatEndpoint: '196',
    camForFirstRobotics: '203',
    /**
     ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
     *** WHEN YOU ADD A FORM MAKE SURE TO UPDATE simpleIdToActionMap
     ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
     */
};
FormIdUtil.simpleIdToActionMap = {
    [FormIdUtil.names.contactUs]: 'Contact Us',
    [FormIdUtil.names.demoRequest]: 'Demo Request',
    [FormIdUtil.names.webinarRegistration]: 'Webinar Registration',
    [FormIdUtil.names.webinarRegistration2023]: 'Webinar Registration',
    [FormIdUtil.names.eduEnterpriseRequest]: 'EDU Enterprise Request',
    [FormIdUtil.names.startupProgram]: 'Startup Program',
    [FormIdUtil.names.wwwContactSales]: 'Contact Sales',
    [FormIdUtil.names.eduAcademicWebinarRegistration]: 'EDU Webinar Registration',
    [FormIdUtil.names.gatedContentProgressiveProfile]: 'DEPRECATED FORM',
    [FormIdUtil.names.productSignupLandingPageHidden]: 'Hidden Product Signup Landing',
    [FormIdUtil.names.wwwGetStartedContact]: 'Get Started Contact',
    [FormIdUtil.names.trialHiddenForm]: 'Trial Hidden',
    [FormIdUtil.names.eduProductSignupHidden]: 'DEPRECATED FORM',
    [FormIdUtil.names.referAFriendReferrer]: 'Refer a Friend Referrer',
    [FormIdUtil.names.referAFriendReferred]: 'Refer a Friend Referred',
    [FormIdUtil.names.emailSubscriptionPreferences]: 'Preference Center',
    [FormIdUtil.names.internalReferral]: 'Internal Referral',
    [FormIdUtil.names.requestProTrialFromFree]: 'Request Pro Trial From Free',
    [FormIdUtil.names.upgradeRenderStudio]: 'Render Studio Upgrade',
    [FormIdUtil.names.upgradeStandardToPro]: 'Upgrade Standard to Pro',
    [FormIdUtil.names.eduForm]: 'Edu Signup Request',
    [FormIdUtil.names.eventForm]: 'Event Registration Form',
    [FormIdUtil.names.signupSurvey]: 'Signup Survey',
    [FormIdUtil.names.creatorProgram]: 'Creator Program',
    [FormIdUtil.names.unifiedSignup]: 'Unified Signup',
    [FormIdUtil.names.mdaEventForm]: 'MDA Registration',
    [FormIdUtil.names.camStudioForm]: 'CAM Studio Feature Signup',
    [FormIdUtil.names.collegiateSponsorship]: 'Collegiate Sponsorship Signup',
    [FormIdUtil.names.upgradeToEducator]: 'Upgrade to Educator',
    [FormIdUtil.names.referToDisco]: 'Refer a Friend - Ref2Disco',
    [FormIdUtil.names.qaHeartBeatEndpoint]: 'QA HeartBeat Endpoint',
    [FormIdUtil.names.contactSales]: 'Contact Sales',
    [FormIdUtil.names.camForFirstRobotics]: 'CAM for First Robotics',
};
export default FormIdUtil;
